module.exports = __webpack_public_path__ + "img/富源县中医医院.db11f3ab.png";